import { ErrorMessage, Field } from "formik";
export enum CheckBoxStyle {
  Normal = 1,
  Switch = 2,
}

interface CheckboxFieldProps {
  label: string;
  name: string;
  checkstyle: CheckBoxStyle;
  isChecked?:boolean;
}

export const CheckboxField = ({
  name,
  label,
  checkstyle,
  isChecked=true
}: CheckboxFieldProps): any => {
  return (
    <div>
      {checkstyle === CheckBoxStyle.Switch ? (
        <>
          <div>
            <label className="switch">
              <Field
                id="txt_client"
                className="k-checkbox k-checkbox-md k-rounded-md"
                type="checkbox"
                checked = {isChecked}
                name={name}
              />
              <span className="slider round"></span>
            </label>
            <label style={{ padding: "5px" }}>{label}</label>
          </div>

          <small className="errorMsg">
            <ErrorMessage name={name} />
          </small>
        </>
      ) : (
        <>
          <div>
            <label className="label">
              <Field
                id="txt_client"
                className="k-checkbox k-checkbox-md k-rounded-md"
                type="checkbox"
                name={name}
              />{" "}
              {label}
            </label>
            <small className="errorMsg">
              <ErrorMessage name={name} />
            </small>
          </div>
        </>
      )}
    </div>
  );
};
